// extracted by css-extract-rspack-plugin
var _1 = "vEC4OXei8skgCQAK";
var _2 = "FQrgXLs7Nm4smcgX";
var _3 = "ZNjKJOugZfwLojOO";
export { _1 as "childrenHolder", _2 as "defaultContentStyle", _3 as "overlay" }
